module.exports = __webpack_public_path__ + "assets/img/text-to-speech-app4.6fc72961.png";